<template>
  <el-dialog
    title="创建优惠劵"
    :visible.sync="visible"
    width="540px"
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      status-icon
      :model="info"
      :rules="rules"
      label-width="110px"
      @submit.native.prevent>
      <el-form-item
        key="couponName"
        label="优惠劵名称:"
        prop="couponName">
        <el-input v-model="info.couponName"></el-input>
      </el-form-item>
      <el-form-item
        key="scope"
        label="适用商品:"
        prop="scope">
        <el-radio-group v-model="info.scope">
          <el-radio :label="1">全品</el-radio>
          <el-radio :label="0">单品</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        key="couponType"
        label="优惠劵类型:"
        prop="couponType">
        <el-radio-group v-model="info.couponType">
          <el-radio :label="1">满减券</el-radio>
          <el-radio :label="2">折扣券</el-radio>
          <el-radio
            v-if="buildMode !== 'SH_WEB'"
            :label="5">每满减券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="info.scope === 0"
        key="products"
        label="商品:"
        prop="products">
        <el-button
          type="primary"
          style="margin-bottom: 5px;"
          @click="selectGoods">选择商品</el-button>
        <el-table
          v-if="info.products.length"
          border=""
          :data="info.products">
          <el-table-column
            prop="goodsName"
            label="商品名称">
          </el-table-column>
          <el-table-column
            prop="goodsDesc"
            label="商品描述">
          </el-table-column>
          <el-table-column label="售价">
            <template slot-scope="{ row }">
              ¥{{ row.price }}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item
        key="validTimeType"
        label="时长类型:"
        prop="validTimeType">
        <el-radio-group v-model="info.validTimeType">
          <el-radio :label="1">限定时长</el-radio>
          <el-radio :label="2">固定时长</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="info.validTimeType === 1"
        key="time"
        label="使用时间:"
        prop="time">
        <el-date-picker
          v-model="info.time"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        v-else
        key="effectiveDays"
        label="时长（天）:"
        prop="effectiveDays">
        <el-input-number
          v-model="info.effectiveDays"
          :min="1"
          :precision="0"></el-input-number>
        <span style="color:red;font-size:12px;">注：从用户领取是时开始计算有效期</span>
      </el-form-item>
      <el-form-item
        key="receiveTime"
        label="发券时间:"
        prop="receiveTime">
        <el-date-picker
          v-model="info.receiveTime"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item
        label="适用范围:"
        prop="userLevel">
        <el-radio-group v-model="info.userLevel">
          <el-radio-button :label="0">新人</el-radio-button>
          <el-radio-button :label="1">会员</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="优惠额度:">
        <el-row v-if="info.couponType === 1 || info.couponType === 5">
          <el-col :span="2">
            {{ info.couponType === 5 ? '每' : '' }}满
          </el-col>
          <el-col :span="10">
            <el-form-item
              key="fullMoney"
              prop="fullMoney">
              <el-input-number
                v-model="info.fullMoney"
                :min="0"
                style="width:100%"
                :precision="2"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            减
          </el-col>
          <el-col :span="10">
            <el-form-item
              key="money"
              prop="money">
              <el-input-number
                v-model="info.money"
                :min="0"
                :disabled="!info.fullMoney"
                :max="info.fullMoney"
                style="width:100%"
                :precision="2"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <span v-else>
          <el-input-number
            v-model="info.money"
            :min="0.1"
            :max="9.9"
            style="width:90%"
            :precision="2"></el-input-number>折
        </span>
      </el-form-item>
      <el-form-item
        key="totalCount"
        label="库存:"
        prop="totalCount">
        <el-input-number
          v-model="info.totalCount"
          :min="1"
          :precision="0"></el-input-number>
      </el-form-item>
      <el-form-item
        key="receiveLimit"
        label="一人限领一张:"
        prop="receiveLimit">
        <el-radio-group v-model="info.receiveLimit">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </template>
    <goods-select-modal
      ref="modal"
      :callback="formatSelected" />
  </el-dialog>
</template>

<script>
import moment from 'moment'
import GoodsSelectModal from './goods-select-modal.vue'
import _ from 'lodash'
export default {
  name: 'CouponRegModal',
  components: { GoodsSelectModal },
  props: {
    callback: Function
  },
  data() {
    return {
      buildMode: process.env.VUE_APP_BUILD_MODE,
      loading: false,
      visible: false,
      info: {
        vendorId: null,
        couponName: '',
        money: undefined,
        fullMoney: undefined,
        couponType: 1,
        scope: 1,
        userLevel: 0,
        validTimeType: 1,
        time: null,
        // beginTime: null,
        // endTime: null,
        receiveTime: null,
        // receiveBeginTime
        // receiveEndTime
        effectiveDays: 1,
        receiveLimit: 1,
        totalCount: undefined,
        products: []
      },
      rules: {
        couponName: [
          { required: true, message: '请输入优惠劵名称', trigger: 'blur' }
        ],
        userLevel: [
          { required: true, message: '请选择适用范围', trigger: 'blur' }
        ],
        fullMoney: [
          { required: true, message: '请输入满减金额', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入满减金额', trigger: 'blur' }
        ],
        totalCount: [
          { required: true, message: '请输入库存', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请选择使用时间', trigger: 'blur' }
        ],
        receiveTime: [
          { required: true, message: '请选择发券时间', trigger: 'blur' }
        ],
        effectiveDays: [
          { required: true, message: '请输入时长', trigger: 'blur' }
        ],
        products: [
          { required: true, message: '请输入商品', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    'info.couponType'(val) {
      if (val === 2) {
        this.info.fullMoney = undefined
        this.info.money = 9.9
      } else {
        this.info.fullMoney = undefined
        this.info.money = undefined
      }
    }
  },
  methods: {
    add(vendorId) {
      this.info.vendorId = vendorId
      this.toggleModal(true)
    },
    update(row) {
      this.info.vendorId = row.vendorId
      this.getVendor(() => {
        this.toggleModal(true)
      })
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.info = { ...this.info, ...this.$options.data().info }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      console.log(this.$refs.ruleForm.validate)
      this.$refs.ruleForm.validate(valid => {
        console.log(valid)
        if (valid) {
          this.loading = true
          const info = { ...this.info }
          const time = this.info.time
          info.beginTime = info.validTimeType === 1 ? +moment(time[0]).startOf('days') : null
          info.endTime = info.validTimeType === 1 ? +moment(time[1]).endOf('days') : null
          const receiveTime = this.info.receiveTime
          info.receiveBeginTime = +moment(receiveTime[0]).startOf('days')
          info.receiveEndTime = +moment(receiveTime[1]).endOf('days')
          info.effectiveDays = info.validTimeType === 1 ? null : info.effectiveDays
          info.products = info.scope === 0 ? this.info.products.map(i => ({ exchangeGoodsId: i.exchangeGoodsId })) : []
          delete info.time
          const fullMoney = this.info.couponType === 2 ? 0 : this.info.fullMoney
          this.$store.dispatch(`coupon/addcoupon`, {
            payload: { ...info, fullMoney },
            success: () => {
              this.loading = false
              this.callback && this.callback()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    formatSelected(data) {
      data = _.cloneDeep(data)
      this.info.products = [data]
    },
    selectGoods() {
      this.$refs.modal.fetch()
    },
    getVendor(cb) {
      this.loading = true
      this.$store.dispatch('account/getvendor', {
        payload: {
          vendorId: this.info.vendorId
        },
        success: res => {
          this.loading = false
          res.data.unifiedCreditFile = (res.data.unifiedCreditFile ? res.data.unifiedCreditFile.split(',') : []).map(item => {
            return {
              url: item
            }
          })
          this.info = {
            ...this.info,
            ...res.data
          }
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
